/*
  Change Shoprite's Sign Out Button Route to be a hash
  and bind my own event listener

*/
import Promise from 'bluebird';
import store from '../../redux/store';
import { invalidateAllAuth, samlSignOut } from '../../redux/auth/actions';

const redirectHref = '//plan.shoprite.com?diffuser=1'; // set by ShopRite

export default function searchForSignoutButton(timeLimit=300) {
  var signoutBtns = document.querySelectorAll(`a[href*="${redirectHref}"]`);
  var currNumSearches = 0;

  if (signoutBtns && signoutBtns.length > 0) {
    changeShopriteSignoutButtonRoute(signoutBtns);
  } else if (currNumSearches < timeLimit) {
    currNumSearches++;
    setTimeout(() => searchForSignoutButton(timeLimit), 1000);
  }
}

function changeShopriteSignoutButtonRoute(btnEls) {
  btnEls.forEach(el => {
    el.setAttribute('href', '#');
    console.log('signout href changed');
    // Set window URL to redirect Href
    el.addEventListener('click', () => {
      Promise.resolve()
        .then(() => samlSignOut()) // Sign out SAML
        .then(() => invalidateAllAuth()(store.dispatch)) // Sign out Web App
        .then(() => window.location = ('/saml')) // redirect ShopRite signout
        .catch((err) => {
          console.error('Failed to edit signout button.');
          console.error(err);
        });
    }, false);
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/shopriteSignOutButton.js